import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { UI_EVENT_TYPE, OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { fg } from '@atlaskit/platform-feature-flags';
import { captureAndReportError } from '../error-reporting';
import { BridgeClientError } from './bridge';
import { blocklistedErrorMessagePatterns } from './blocklistedErrorMessagePatterns';
import { FORGE_UI_ANALYTICS_CHANNEL } from '../analytics';
import { trackBridgeSucceed, trackBridgeFailed } from '../analytics/useForgeUiAnalyticsEvent';
var wrapFeatureWithMetricsAndAnalytics = function wrapFeatureWithMetricsAndAnalytics(_ref) {
  var feature = _ref.feature,
    createAnalyticsEvent = _ref.createAnalyticsEvent,
    page = _ref.page,
    bridgeMethod = _ref.bridgeMethod,
    environment = _ref.environment,
    errorExtensionDetails = _ref.errorExtensionDetails,
    tracing = _ref.tracing;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var result, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            tracing === null || tracing === void 0 || tracing.recordBridgeCall("".concat(bridgeMethod, "() - start"));
            _context.next = 4;
            return feature(payload);
          case 4:
            result = _context.sent;
            tracing === null || tracing === void 0 || tracing.recordBridgeCall("".concat(bridgeMethod, "() - end"));
            if (bridgeMethod === 'on') {
              createAnalyticsEvent({
                eventType: OPERATIONAL_EVENT_TYPE,
                data: {
                  action: 'subscribed',
                  actionSubject: 'bridgeEvent',
                  attributes: {
                    // TODO: remove the condition (and related test) once Developer UGC spec is ready
                    event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                  },
                  source: page,
                  tags: ['forge']
                }
              }).fire(FORGE_UI_ANALYTICS_CHANNEL);
            }

            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            if (fg('platform.forge-ui.use-new-event-schema')) {
              trackBridgeSucceed(createAnalyticsEvent, {
                source: page
              });
            }

            // Remove the old event once we've confirmed the new schema and dashboards are working
            // https://ecosystem-platform.atlassian.net/browse/EXT-2196
            createAnalyticsEvent({
              eventType: UI_EVENT_TYPE,
              data: {
                action: 'called',
                actionSubject: 'bridge',
                attributes: {
                  method: bridgeMethod
                },
                source: page,
                tags: ['forge']
              }
            }).fire(FORGE_UI_ANALYTICS_CHANNEL);
            return _context.abrupt("return", result);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            error = _context.t0 instanceof Error ? _context.t0 : new Error("Unknown Custom UI Bridge error: ".concat(_typeof(_context.t0)));
            if (!(error instanceof BridgeClientError)) {
              if (!blocklistedErrorMessagePatterns.some(function (pattern) {
                return pattern.test(error.message);
              })) {
                if (fg('platform.forge-ui.use-new-event-schema')) {
                  trackBridgeFailed(createAnalyticsEvent, {
                    source: page,
                    errorName: error.name
                  });
                }

                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                  eventType: UI_EVENT_TYPE,
                  data: {
                    action: 'errored',
                    actionSubject: 'bridge',
                    attributes: {
                      method: bridgeMethod
                    },
                    tags: ['forge']
                  }
                }).fire(FORGE_UI_ANALYTICS_CHANNEL);
                captureAndReportError({
                  error: error,
                  environment: environment,
                  errorExtensionDetails: errorExtensionDetails,
                  page: page,
                  tracing: tracing
                });
              }
            }
            throw _context.t0;
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var withMetricsAndAnalytics = function withMetricsAndAnalytics(_ref3) {
  var features = _ref3.features,
    createAnalyticsEvent = _ref3.createAnalyticsEvent,
    page = _ref3.page,
    environment = _ref3.environment,
    errorExtensionDetails = _ref3.errorExtensionDetails,
    tracing = _ref3.tracing;
  return Object.entries(features).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      feature = _ref5[1];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, wrapFeatureWithMetricsAndAnalytics({
      feature: feature,
      createAnalyticsEvent: createAnalyticsEvent,
      page: page,
      bridgeMethod: key,
      environment: environment,
      errorExtensionDetails: errorExtensionDetails,
      tracing: tracing
    })));
  }, {});
};